import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@mui/material';
import React from 'react';

const InputSearch = ({value, setSearch, handleSearch, isLoading}) => {
    return (
        <div className="form-group">
            <div className="position-relative" style={{maxWidth: '340px'}}>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por número de presupuesto"
                    value={value}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSearch();
                    }}
                />

                {isLoading ? (
                    <div
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CircularProgress
                            size={18}
                            style={{ color: '#215732' }}
                        />
                    </div>
                ) : (
                    <FontAwesomeIcon
                        icon={faSearch}
                        className="icon"
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#215732',
                            cursor: 'pointer',
                        }}
                        onClick={handleSearch}
                    />
                )}
            </div>
        </div>
    );
};

export default InputSearch;
